import React from 'react';
import { LazyGigPagePjmBanner } from '@fiverr-private/upmarket_banners';
import { BannerWrapper } from '../components/BannerWrapper';

export const PjmBanner: React.FC = () => (
  <BannerWrapper>
    <LazyGigPagePjmBanner />
  </BannerWrapper>
);
